export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";